import React from 'react'
import EventControlRoomView from '../components/EventControlRoomView'
import hipladeTemplate from '../../common/template'

function EventControlRoom() {
  return <EventControlRoomView />
}

export default hipladeTemplate(EventControlRoom)
